import { render, staticRenderFns } from "./SaveToBook.vue?vue&type=template&id=63de6594&scoped=true"
import script from "./SaveToBook.vue?vue&type=script&lang=ts"
export * from "./SaveToBook.vue?vue&type=script&lang=ts"
import style0 from "./SaveToBook.vue?vue&type=style&index=0&id=63de6594&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63de6594",
  null
  
)

export default component.exports